import { useState } from "react"
import { Box, Container, IconButton, Typography } from "@mui/material"
import { Close } from "@mui/icons-material"

import { homeCopy } from "../../../content/homeCopy"

const PromoBar = () => {
    const [open, setOpen] = useState(true)

    if (!open) return null

    return (
        <Box
            component="aside"
            sx={{
                background: "rgba(0, 163, 255, 0.18)",
                borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
            }}
        >
            <Container maxWidth="lg">
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1,
                        py: 1,
                        position: "relative",
                        px: 4,
                    }}
                >
                    <Typography
                        variant="body2"
                        textAlign="center"
                        fontWeight={600}
                        sx={{ color: "#fff" }}
                    >
                        {homeCopy.promoBar}
                    </Typography>
                    <IconButton
                        size="small"
                        aria-label="Dismiss announcement"
                        onClick={() => setOpen(false)}
                        sx={{ position: "absolute", right: 0, color: "#fff" }}
                    >
                        <Close fontSize="small" />
                    </IconButton>
                </Box>
            </Container>
        </Box>
    )
}

export default PromoBar
